// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__31eKK","Divider":"Auth_Divider__2YLDC"};